class BoxShadow {
    shadows = [];

    constructor(hOffset, vOffset, blur, spread, color) {
        this.shadows.push(new Shadow(hOffset, vOffset, blur, spread, color, this));
    }

    addShadow(hOffset, vOffset, blur, spread, color) {
        this.shadows.push(new Shadow(hOffset, vOffset, blur, spread, color, this));
    }

    getShadow(index) {
        return this.shadows[index];
    }

    toString() {
        return this.shadows.join(', ');
    }
}

class Shadow {
    parent = null;

    isHidden = false;
    isInset = false;

    hOffset = 0;
    vOffset = 0;
    blur = 0;
    spread = 0;
    color = '#000';

    setSpread(spread) {
        this.spread = spread;
        return this;
    }
    setColor(color) {
        this.color = color;
        return this;
    }

    getParent() {
        return this.parent;
    }

    constructor(hOffset, vOffset, blur, spread, color, parent) {
        this.hOffset = hOffset;
        this.vOffset = vOffset;
        this.blur = blur;
        this.spread = spread;
        this.color = color;

        this.parent = parent;
    }

    toString() {
        let shadow = '';
        shadow += this.hOffset;
        shadow += ' ' + this.vOffset;
        shadow += ' ' + this.blur;
        shadow += ' ' + this.spread;
        shadow += ' ' + this.color;

        return shadow;
    }
}

export default BoxShadow;